module.exports = __webpack_public_path__ + "static/img/qtcj02.c32a10f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj02.png
// module id = 462
// module chunks = 0